import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import { ScrollArea } from "./ui/scroll-area";
import { FOOTER, NAV_ITEMS, LINKS, LEGAL } from "../mock";

const LEGAL_LINKS = [
  { key: "privacy", label: "Privacy Policy" },
  { key: "terms", label: "Terms of Service" },
  { key: "risk", label: "Risk Disclosure" },
  { key: "affiliate", label: "Affiliate Disclosure" },
];

const Footer = () => {
  const [openDoc, setOpenDoc] = useState(null);
  const doc = openDoc ? LEGAL[openDoc] : null;

  return (
    <footer className="relative border-t border-white/[0.06] bg-[#080706]">
      <div className="max-w-6xl mx-auto px-5 sm:px-6 py-16">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          {/* Brand + tagline */}
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <img src="/copy-compass-icon.png" alt="Copy Compass" className="h-9 w-auto" />
              <span className="font-display font-700 text-[1.05rem] gold-text">{FOOTER.brand}</span>
            </a>
            <p className="text-[#a49e92] text-[0.95rem] leading-relaxed mt-5 max-w-sm">
              {FOOTER.tagline}
            </p>
            <p className="text-[#6e685c] text-[0.8rem] mt-4 leading-relaxed max-w-sm">
              Copy Compass is a trading name used by {FOOTER.operator}. We provide general information
              about third-party automated trading services and do not provide personalized investment
              advice.
            </p>
          </div>

          {/* Navigate */}
          <div>
            <h4 className="section-label !tracking-[0.2em] mb-5">Navigate</h4>
            <ul className="space-y-3">
              {NAV_ITEMS.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="text-[0.9rem] text-[#a49e92] hover:text-white transition-colors"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href={LINKS.discord}
                  target="_blank"
                  rel="noreferrer"
                  className="text-[0.9rem] text-[#a49e92] hover:text-white transition-colors"
                >
                  Discord Community
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="section-label !tracking-[0.2em] mb-5">Legal</h4>
            <ul className="space-y-3">
              {LEGAL_LINKS.map((item) => (
                <li key={item.key}>
                  <button
                    onClick={() => setOpenDoc(item.key)}
                    className="text-[0.9rem] text-[#a49e92] hover:text-white transition-colors text-left"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Disclaimer + copyright */}
        <div className="mt-14 pt-8 border-t border-white/[0.06]">
          <p className="text-[#6e685c] text-[0.78rem] leading-relaxed max-w-4xl">{FOOTER.disclaimer}</p>
          <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <p className="text-[#6e685c] text-[0.78rem]">
              © {new Date().getFullYear()} {FOOTER.copyright}. All rights reserved.
            </p>
            <div className="flex flex-wrap gap-x-5 gap-y-2">
              {LEGAL_LINKS.map((item) => (
                <button
                  key={item.key}
                  onClick={() => setOpenDoc(item.key)}
                  className="text-[0.78rem] text-[#6e685c] hover:text-[#c7c1b5] transition-colors"
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Legal modal */}
      <Dialog open={!!openDoc} onOpenChange={(o) => !o && setOpenDoc(null)}>
        <DialogContent className="bg-[#0e0d0b] border border-white/10 text-white max-w-2xl p-0 gap-0">
          <DialogHeader className="px-6 sm:px-8 pt-7 pb-5 border-b border-white/[0.07]">
            <DialogTitle className="font-display font-700 text-[1.5rem] gold-text text-left">
              {doc?.title}
            </DialogTitle>
            <DialogDescription className="text-[#8a8478] text-[0.82rem] text-left mt-1">
              {doc?.updated}
            </DialogDescription>
          </DialogHeader>
          <ScrollArea className="max-h-[62vh] px-6 sm:px-8 py-6">
            <div className="space-y-6 pr-2">
              {doc?.sections.map((s, i) => (
                <div key={i}>
                  <h5 className="font-display font-600 text-white text-[1rem] mb-2">{s.h}</h5>
                  <p className="text-[#a49e92] text-[0.9rem] leading-relaxed">{s.p}</p>
                </div>
              ))}
              <p className="text-[#6e685c] text-[0.76rem] leading-relaxed pt-2 border-t border-white/[0.06]">
                This document is provided for general informational purposes and does not constitute
                legal or financial advice.
              </p>
            </div>
          </ScrollArea>
        </DialogContent>
      </Dialog>
    </footer>
  );
};

export default Footer;
